import React, { Fragment, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { ProgressIcon } from '~/shared';
import { Divider } from '../Divider';
import { NotificationText } from '../NotificationText';
import { getProgressIcon } from './ProgressNotification.model';
import {
	StyledNotificationContainer,
	StyledProgress,
} from './ProgressNotification.styled';

interface IHudProgressNotificationProps
	extends React.HTMLAttributes<HTMLDivElement> {
	text: string;
	duration: number;
	icon?: ProgressIcon;
	$layerIndex?: number;
}

const ProgressNotification: React.FC<IHudProgressNotificationProps> = ({
	text,
	duration,
	icon,
	...props
}: IHudProgressNotificationProps) => {
	const [progress, setProgress] = useState<number>(0);

	useEffectOnce(() => {
		setProgress(100);
	});

	return (
		<StyledNotificationContainer {...props}>
			<StyledProgress
				$progress={progress}
				style={{ transition: `width ${duration}ms linear` }}
			/>
			{icon && (
				<Fragment>
					<img src={getProgressIcon(icon)} />
					<Divider $color={'white'} />
				</Fragment>
			)}
			<NotificationText $color={'white'}>{text}</NotificationText>
		</StyledNotificationContainer>
	);
};

export { ProgressNotification };
